import React, { ReactNode } from 'react';
import { motion, MotionProps } from 'framer-motion';

type Direction = 'left' | 'right' | 'up' | 'down';

interface SlideInProps extends MotionProps {
  children: ReactNode;
  direction?: Direction;
  distance?: number;
  delay?: number;
  duration?: number;
  className?: string;
}

/**
 * SlideIn component that animates children with a slide-in effect from a specified direction
 */
export const SlideIn: React.FC<SlideInProps> = ({
  children,
  direction = 'left',
  distance = 50,
  delay = 0,
  duration = 0.5,
  className = '',
  ...rest
}) => {
  const getInitialPosition = () => {
    switch (direction) {
      case 'left':
        return { x: -distance, y: 0 };
      case 'right':
        return { x: distance, y: 0 };
      case 'up':
        return { x: 0, y: -distance };
      case 'down':
        return { x: 0, y: distance };
      default:
        return { x: -distance, y: 0 };
    }
  };

  return (
    <motion.div
      initial={{ ...getInitialPosition(), opacity: 0 }}
      animate={{ x: 0, y: 0, opacity: 1 }}
      exit={{ ...getInitialPosition(), opacity: 0 }}
      transition={{ duration, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export default SlideIn;